
import React from 'react';
import './PageStyles.css';
import './Home.css';

// Image imports from assets
import screen1 from '../assets/screen1.png';
import screen2 from '../assets/screen2.jpg';
import screen3 from '../assets/screen3.jpg';
import screen4 from '../assets/screen4.jpg';
import screen5 from '../assets/screen5.jpg';
import screen6 from '../assets/screen6.jpg';
import screen7 from '../assets/screen7.jpg';
import screen8 from '../assets/screen8.jpg';
import screen9 from '../assets/screen9.jpg';

const screenshots = [
  screen1,
  screen2,
  screen3,
  screen4,
  screen5,
  screen6,
  screen7,
  screen8,
  screen9,
];

function Home() {
  return (
    <div className="page home">
      {/* Heading */}
      <h1>Welcome to <span className="brand">TestYodha</span></h1>
      <p className="tagline"><b>Your Battle For Success Begins Here</b></p>
      <p className="launch-text">🚀 App launching soon on Play Store & App Store!</p>

      {/* Store badges */}
      <div className="store-buttons">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          alt="Get it on Google Play"
          className="store-badge"
          onClick={() => alert('App will be available soon on Play Store!')}
        />
        <img
          src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
          alt="Download on the App Store"
          className="store-badge"
          onClick={() => alert('App will be available soon on App Store!')}
        />
      </div>

      {/* YouTube Section */}
      <div className="youtube-section">
        <h2>🎥 Watch Our Academy in Action</h2>
        <div className="video-grid">
          <a href="https://www.youtube.com/watch?v=9utA6NN36NU" target="_blank" rel="noreferrer">
            <img src="https://img.youtube.com/vi/9utA6NN36NU/0.jpg" alt="Video 1" className="yt-grid-thumb" />
          </a>
          <a href="https://www.youtube.com/watch?v=fjsEtoqzNrY" target="_blank" rel="noreferrer">
            <img src="https://img.youtube.com/vi/fjsEtoqzNrY/0.jpg" alt="Video 2" className="yt-grid-thumb" />
          </a>
          <a href="https://www.youtube.com/watch?v=_DZYgIq7RTY" target="_blank" rel="noreferrer">
            <img src="https://img.youtube.com/vi/_DZYgIq7RTY/0.jpg" alt="Video 3" className="yt-grid-thumb" />
          </a>
        </div>
        <a href="https://www.youtube.com/@faujdardefenceacademy723" target="_blank" rel="noreferrer">
          <button className="yt-btn">▶️ Watch More Videos on YouTube</button>
        </a>
      </div>

      {/* Carousel */}
      <div className="carousel">
        <h2>Development in progress — sneak peek of the upcoming TestYodha app</h2>
        <p></p>
        <div className="carousel-track">
          {[...screenshots, ...screenshots].map((src, index) => (
            <img key={index} src={src} alt={`screenshot ${index + 1}`} className="carousel-img" />
          ))}
        </div>
      </div>

      {/* Platform Info */}
    <div className="content-section">
  <h2>All-in-One Test Prep Platform</h2>
  <p>
  From strategy to selection — TestYodha gives you everything:  
  Mock tests, notes, PYQs, real-time performance insights, and more.  
  Built for aspirants who dream big and aim high.
</p>
<p>
  Padho wahi jo important hai, do tests jo exam jaisa feel de.  
  TestYodha tumhari preparation ko banata hai smarter, faster, aur targeted.  
  NDA ho ya CDS — yahan har effort ka matlab selection hai.
</p>

</div>
    </div>
  );
}

export default Home;